import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { useKycLogout } from "./use-kyc-logout";
import { toSentenceCase } from "@/lib/utils";

const KycRejected = ({
  reviewNote,
  onResubmit,
}: {
  reviewNote?: string | null;
  onResubmit: () => void;
}) => {
  const logout = useKycLogout();

  return (
    <div className="mx-auto mt-6 flex w-full max-w-xl grow flex-col justify-center text-center lg:mt-0">
      <span className="mx-auto flex size-24 items-center justify-center rounded-full bg-red-500/15 lg:size-28">
        <XCircle className="size-12 text-red-500" />
      </span>
      <h1 className="mt-6 text-2xl font-semibold lg:text-3xl">
        Verification not approved
      </h1>
      <p className="text-dark-text-300 mx-auto mt-3 max-w-md text-sm lg:text-base">
        We couldn&apos;t verify your identity with the details you submitted.
        Please review the note below and submit again.
      </p>

      <div className="mt-8 rounded-2xl border border-red-500/30 bg-red-500/5 p-4 text-left">
        <h2 className="font-semibold">Reason from our team</h2>
        <p className="mt-1 text-sm">
          {reviewNote
            ? toSentenceCase(reviewNote)
            : "No reason was given. Please check your details."}
        </p>
        <p className="text-dark-text-300 mt-3 text-xs">
          Your previous details are saved. You only need to fix what was wrong
          and upload your documents again.
        </p>
      </div>

      <Button
        onClick={onResubmit}
        className="mt-8 h-11 w-full rounded-xl bg-[#2F2F2F] text-white hover:bg-[#2F2F2F]/90"
      >
        Resubmit verification
      </Button>
      <Button
        variant="outline"
        onClick={logout}
        className="mt-3 h-11 w-full rounded-xl border-[#CECECE2E] bg-transparent hover:bg-black/5"
      >
        Logout
      </Button>
    </div>
  );
};

export default KycRejected;
